import { render, staticRenderFns } from "./UiIconClose.vue?vue&type=template&id=764e8f0b&"
import script from "./UiIconClose.vue?vue&type=script&lang=js&"
export * from "./UiIconClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports